export default "/images/vendor/flag-icon-css/flags/1x1/rs.svg?3b67d7bed888271edff679c68117af49";